import React from 'react'
import { useForm } from 'react-hook-form';
import {
    Input,
    Button,
    Typography,
    Spinner
} from "@material-tailwind/react";

import { useShared } from '../../hooks/useShared';
import AIcon from '../partials/AIcon';
import AInput from '../fields/AInput';
import ReCAPTCHA from "react-google-recaptcha"

const email = { label: 'Email', name: 'email', type: 'email', roles: [1], icon: 'mail-outline', className: '', required: 'Email address is requieed', isStyle: true };
const phone = { label: 'Phone Number', name: 'phone', type: 'text', roles: [1], icon: 'phone-portrait-sharp', className: '', required: 'Phone number is requieed', isStyle: true };
const password = { label: 'Password', name: 'password', type: 'password', roles: [1], icon: 'eye-outline', className: '', required: 'Password is requieed', isStyle: true };
const password_confirmation = { label: 'Confirmation Password', name: 'password_confirmation', type: 'password', roles: [1], icon: 'eye-outline', className: '', required: 'Password is requieed', isStyle: true };


export default function Register() {
    const {
        register,
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm();

    const { auth } = useShared();
    const [isCaptchaSuccessful, setIsCaptchaSuccess] = React.useState(false);

    const submit = (data) => {
        auth.signUp(data, reset)
    }

    function handelCpatcha(value) {
      setIsCaptchaSuccess(true)
      console.log("captcha value:", value);
    }
  

    return (
        <div>

            {auth.successMsg ?
                <p className='py-4 px-2 bg-green-100 rounded-lg my-5 text-green-900'>{auth.successMsg}. To login, please click on the top Login tab </p> :
                <form className="mt-5 flex flex-col gap-4" onSubmit={handleSubmit(submit)}>

                    <div className='grid gap-3'>
                        <AInput v={{ data: email, register, errors, control }} />
                        <AInput v={{ data: phone, register, errors, control }} />
                        <AInput v={{ data: password, register, errors, control }} />
                        <AInput v={{ data: password_confirmation, register, errors, control }} />

                        <ReCAPTCHA
                           sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                           onChange={handelCpatcha}
                        />

                    </div>

                    {auth.errorMessage && <Typography
                        variant="small"
                        color="gray"
                        className="mt-1 flex items-center text-red-500 gap-2 font-normal "
                    >
                        <AIcon name="alert-circle-outline" className="-mt-0.5 h-4 w-4" />
                        {auth.errorMessage}
                    </Typography>}
                    <Button className="bg-main-color flex justify-center" type="submit" disabled={auth.loading ||!isCaptchaSuccessful}>  {auth.loading ? <Spinner color="teal" className="h-4 w-4" /> : "Register"}    </Button>

                </form>}
        </div>
    )
}
